<template>
    <a-table
          :rowKey="
            (record, index) => {
              return index
            }
          "
          :columns="columns"
          :loading="tableLoading"
          :pagination="pagination"
          @change="handleChangeInTable"
          :data-source="tableData"
          :customRow="customRow"
        >
            
          <a slot="name" slot-scope="text">{{ text }}</a>
          <template slot="contractCode" slot-scope="contractCode">
            <h1 style="color: var(--ThemeColor)">{{ contractCode }}</h1>
          </template>
          <!-- <slot></slot> -->
          <!-- <template v-for="el of columns.filter(it=>it.scopedSlots)" >
            <div :key="el.scopedSlots.customRender">
                
            </div>
          </template> -->
    </a-table>
</template>

<script>
export default {
    props:{
        columns:{
            type:Array,
            default:()=>[]
        },
        tableLoading:{
            type:Boolean,
            default:false
        },
        pagination:{
            type:Object,
            default:()=>({})
        },
        tableData:{
            type:Array,
            default:()=>[]
        },
        customRow:{
            type:[Object,Function],
            default:()=>({})
        }

    },
    watch:{
        columns:{
            handler(){

            },
            deep:true,
            immediate:true
        },
        pagination:{
            handler(){},
            deep:true,
            immediate:true
        },
        tableData:{
            handler(){},
            deep:true,
            immediate:true
        }
    },
    data(){
        console.log(this.$slots,'11')
        return {
            
        }
    },
    methods:{
        handleChangeInTable(pagination, filters, sorter){
            
            this.$emit('handleChangeInTable',pagination)
        }
    }
}
</script>

<style lang="less" scoped>

</style>